// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"689":"c27a52d6","978":"80629a62"}[chunkId] + ".chunk.js";
};